import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

export interface Failure {
  code: string;
  reason?: string;
}

const STATUS_FALLBACK: Record<number, string> = {
  400: 'failure.generic',
  404: 'failure.generic',
  500: 'failure.generic',
  503: 'failure.generic',
};

const AUTH_FAILURE_REASON_KEY: Record<string, string> = {
  WRONG_CREDENTIALS: 'failure.wrongCredentials',
  USER_DISABLED: 'failure.userDisabled',
  OTHER: 'failure.other',
};

export function failuresFromResponse(error: unknown, fallbackCode = 'failure.generic'): Failure[] {
  if (error instanceof HttpErrorResponse) {
    const body = error.error;
    if (body?.failures?.length) {
      return dedupe(body.failures);
    }
    return [{ code: STATUS_FALLBACK[error.status] ?? fallbackCode }];
  }
  return [{ code: fallbackCode }];
}

export function authFailureFrom(error: HttpErrorResponse): Failure {
  const reason = error.headers.get('Auth-Failure-Reason') ?? 'OTHER';
  return { code: AUTH_FAILURE_REASON_KEY[reason] ?? AUTH_FAILURE_REASON_KEY['OTHER'] };
}

export function resolveFailureMessage(translate: TranslateService, failure: Failure): string {
  const translated = translate.instant(failure.code);
  return translated !== failure.code ? translated : (failure.reason ?? translated);
}

function dedupe(failures: Failure[]): Failure[] {
  const seen = new Set<string>();
  return failures.filter(failure => !seen.has(failure.code) && seen.add(failure.code));
}
